import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";
import { USER_GROUP } from "src/constants/perks";

export const getAudiences = async () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.get(`${API_URL}/company/emailCampaigns/audience`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    const rawResponse = response.data;

    // Sort the custom audiences so it won't need doing later: employees before clients, and then all the rest
    const unfilteredAudiences = rawResponse.customAudiences;
    const employeesAudiences = unfilteredAudiences.filter(audience => audience.name === USER_GROUP.EMPLOYEES);
    const clientsAudiences = unfilteredAudiences.filter(audience => audience.name === USER_GROUP.CLIENTS);
    const otherAudiences = unfilteredAudiences.filter(audience => ![USER_GROUP.EMPLOYEES, USER_GROUP.CLIENTS].includes(audience.name));
    return {
        ...rawResponse,
        customAudiences: [...employeesAudiences, ...clientsAudiences, ...otherAudiences]
    };
};

export const saveAudience = async (payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.post(`${API_URL}/company/emailCampaigns/audience`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const updateAudience = async (audienceUuid, payload) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.put(`${API_URL}/company/emailCampaigns/audience/${audienceUuid}`, payload, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};

export const deleteAudience = async (categoryId) => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    const response = await axios.delete(`${API_URL}/company/emailCampaigns/audience/${categoryId}`, {
        headers: {
            Authorization: "Bearer " + token
        }
    });
    return response.data;
};
